import * as React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import '@patternfly/patternfly/patternfly-charts.css';
import { Bullseye, PageSection, Spinner } from '@patternfly/react-core';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppLayout } from '@app/AppLayout/AppLayout';
import { AppRoutes } from '@app/routes';
import { configureAmplify } from '@app/utils/amplifyConfig';
import { initMsal } from '@app/utils/entraAuth';
import { googleAnalytics } from '@app/utils/googleAnalytics';
import { SiteConfigProvider, useSiteConfigState } from '@app/config/SiteConfigContext';
import '@app/app.css';
import '../generated/branding.css';

configureAmplify();
void initMsal();

const AppWithConfig: React.FunctionComponent = () => {
  const { config, loading } = useSiteConfigState();
  React.useEffect(() => {
    if (config?.analytics) {
      googleAnalytics.initialize(config.analytics.trackingId, config.analytics.enabled);
    }
  }, [config?.analytics?.enabled, config?.analytics?.trackingId]);

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppLayout>
        {loading ? (
          <PageSection>
            <Bullseye>
              <Spinner size="lg" aria-label="Loading application" />
            </Bullseye>
          </PageSection>
        ) : (
          <AppRoutes />
        )}
      </AppLayout>
    </Router>
  );
};

const App: React.FunctionComponent = () => (
  <SiteConfigProvider>
    <AppWithConfig />
  </SiteConfigProvider>
);

export default App;
